import { sendHierarchyEmail } from "actions/CarrierAgreementMgmt/Hierarchy";
import { useMutation } from "react-query";

const useSendHierarchyEmail = () => {
  return useMutation(sendHierarchyEmail);
};
export default useSendHierarchyEmail;
